
















import { Component, Mixins, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import { UseFields } from '../../../Pi'
import { Coinbase } from '../types'

@Component({})
export default class CoinbaseSetting extends Mixins(UseFields, ModelSetter) {
  @VModel() model!: Coinbase
}
